import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { REDIRECT_PATH_KEY } from '../../../../common/constants/commonConstants.js';
import { paths } from '../../../../common/constants/pathVariables.js';
import { validateExternalAuthUserAuthority } from '../../../../common/fetch.js';
import { convertToCommonErrors } from '../../../../common/utils/errorUtils.js';
import { useAuth } from '../../AuthProvider.js';

const userDetailsKey = 'registration-user-details';

export const useValidateUserAuthority = () => {
  const navigate = useNavigate();
  const { setExternalAuthErrors } = useAuth();

  const validateUserAuthority = useCallback(
    async (authorizationCode: string, businessId: string, redirectPath?: string) => {
      setExternalAuthErrors([]);

      const targetPath = redirectPath
        ? `${paths.REGISTER_PAGE}?${REDIRECT_PATH_KEY}=${encodeURIComponent(redirectPath)}`
        : paths.REGISTER_PAGE;

      try {
        const response = await validateExternalAuthUserAuthority(authorizationCode, businessId);
        sessionStorage.setItem(userDetailsKey, JSON.stringify(response));
        navigate(targetPath, { replace: true });
      } catch (error) {
        const errors = convertToCommonErrors(`ajax error ${error.status}`, error.status);
        setExternalAuthErrors(errors);
        navigate(targetPath, { replace: true });
      }
    },
    [navigate, setExternalAuthErrors]
  );

  return { validateUserAuthority };
};
